export default "__VITE_ASSET__CxDMQyDd__"